<template>
  <v-container
    fill-height
    fluid
    grid-list-md
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        xs12
        md8
      >
        <MaterialCard
          :text="title"
          :color="color"
        >
          <v-form>
            <v-container py-0>
              <v-layout wrap>
                <v-flex
                  xs12
                  md4
                >
                  <v-text-field
                    :value="company.id"
                    label="id"
                    disabled
                  />
                </v-flex>
                <v-flex
                  xs12
                  md4
                >
                  <v-text-field
                    v-model="company.name"
                    class="purple-input"
                    label="会社名"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md4
                >
                  <v-text-field
                    v-model="company.representativeName"
                    class="purple-input"
                    label="代表氏名"
                  />
                </v-flex>
                <v-flex
                  md10
                >
                  <v-text-field
                    v-model="company.address"
                    label="住所"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    v-model="company.tel"
                    label="電話番号"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    v-model="company.remarks"
                    class="purple-input"
                    label="備考"
                  />
                </v-flex>
                <v-flex
                  xs12
                  text-xs-right
                >
                  <v-btn
                    class="mx-0 font-weight-light"
                    color="success"
                    :disabled="!isValid"
                    @click="register"
                  >
                    登録
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </MaterialCard>
      </v-flex>
      <v-flex
        xs12
        md4
      >
        <MaterialCard flat>
          <v-data-table
            :headers="headers"
            :items="company.users"
            hide-actions
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="subheading font-weight-light text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ item }"
            >
              <td>{{ item.no }}</td>
              <td>{{ item.id }}</td>
              <td>{{ item.name }}</td>
              <td>{{ roles[item.rest] }}</td>
              <td>
                <v-btn
                  color="red"
                  @click="removeUser(item.no)"
                >
                  削除
                </v-btn>
              </td>
            </template>
          </v-data-table>
          <v-layout>
            <v-btn
              color="green"
              @click="addUser"
            >
              追加
            </v-btn>
          </v-layout>
        </MaterialCard>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { api } from '@/api'
import { onError } from '@/utils/error-handler'

export default {
  async beforeRouteEnter (to, from, next) {
    if (to.params.id === 'new') {
      next(vm => {
        vm.isNew = true
        vm.company.id = '(自動採番)'
      })
      return
    }

    try {
      const response = await api.getGroup(parseInt(to.params.id), 10)
      return next(vm => {
        vm.isNew = false
        vm.company.id = to.params.id
        vm.company.name = response.group.name
        vm.company.address = response.group.address
        vm.company.tel = response.group.tel
        vm.company.remarks = response.group.remarks
        vm.company.updatedAt = response.group.updatedAt
      })
    } catch (e) {
      onError(next, e)
    }
  },
  async beforeRouteUpdate (to, from, next) {
    if (to.params.id === 'new') {
      this.isNew = true
      this.company.id = '(自動採番)'
      next()
      return
    }

    try {
      const response = await api.getGroup(parseInt(to.params.id), 10)
      this.isNew = false
      this.company.id = to.params.id
      this.company.name = response.group.name
      this.company.address = response.group.address
      this.company.tel = response.group.tel
      this.company.remarks = response.group.remarks
      this.company.updatedAt = response.group.updatedAt
      return next()
    } catch (e) {
      onError(next, e)
    }
  },
  data: () => ({
    title: '入力してください',
    isNew: false,
    company: {
      id: '',
      name: '',
      address: '',
      tel: '',
      remarks: '',
      updatedAt: 0,
      users: []
    },
    headers: [
      { sortable: false, text: '#', value: 'no' },
      { sortable: false, text: 'ユーザID', value: 'id' },
      { sortable: false, text: 'ユーザ名', value: 'name' },
      { sortable: false, text: 'ロール', value: 'role' },
      { sortable: false, text: '' }
    ],
    roles: {
      a: '準システム管理者'
    }
  }),
  computed: {
    isCompanyNameValid () {
      if (this.company.name == null) {
        return false
      }
      if (this.company.name.trim().length === 0) {
        return false
      }
      return true
    },
    isRepresentativeNameValid () {
      if (this.company.representativeName == null) {
        return false
      }
      if (this.company.representativeName.trim().length === 0) {
        return false
      }
      return true
    },
    isAddressValid () {
      if (this.company.address == null) {
        return false
      }
      if (this.company.address.trim().length === 0) {
        return false
      }
      return true
    },
    isTelValid () {
      if (this.company.tel == null) {
        return false
      }
      if (this.company.tel.trim().length === 0) {
        return false
      }
      return true
    },
    isValid () {
      return this.isCompanyNameValid && this.isRepresentativeNameValid && this.isAddressValid && this.isTelValid
    },
    color () {
      if (this.isValid) {
        return 'green'
      } else {
        return 'red'
      }
    }
  },
  methods: {
    async register () {
      const response = await api.createCompany({
        companyName: this.company.name,
        address: this.company.address,
        tel: this.company.tel,
        remarks: this.company.remarks,
        representativeName: this.company.representativeName,
        representativePassword: ''
      })
      this.$router.replace({ name: '提携企業登録', params: { id: response.id } })
    },
    addUser () {
      this.company.users.push({
        no: this.company.users.length + 1,
        id: '',
        name: '',
        role: 'a'
      })
    },
    removeUser (no) {
      const index = this.company.users.findIndex(t => t.no === no)

      if (index !== -1) {
        this.company.users.splice(index, 1)
        this.company.users.forEach((t, i) => {
          t.no = i + 1
        })
      }
    }
  }
}
</script>
